import type { PipelineStage } from '@crm/shared';
import { Link } from 'react-router';
import { compactSar } from './AttentionPeek';

/** Open stages in order get these colours (sky → indigo → violet → amber → green …); won is green, lost grey. */
const OPEN = ['#38bdf8', '#6366f1', '#a855f7', '#f59e0b', '#10b981', '#14b8a6', '#ec4899', '#0ea5e9'];
export function stageColor(stages: PipelineStage[], s: PipelineStage): string {
  if (s.isClosed) return s.isWon ? '#16a34a' : '#94a3b8';
  const open = stages.filter((x) => !x.isClosed);
  return OPEN[Math.max(0, open.findIndex((x) => x.id === s.id)) % OPEN.length]!;
}

export interface StagePart { id: string; label: string; amount: number; count: number; color: string; to?: string }

/** The open value split by stage in one bar, with each stage's amount and deals below (a link when given). */
export function StageBar({ parts, legend = true }: { parts: StagePart[]; legend?: boolean }) {
  const total = parts.reduce((a, p) => a + Math.max(0, p.amount), 0);
  return (
    <div className="sbar">
      <div className="sbar-line" role="img" aria-label={parts.filter((p) => p.amount > 0).map((p) => `${p.label} ${compactSar(p.amount)}`).join(', ') || 'No open value'}>
        {total > 0 ? parts.map((p) => (p.amount > 0 ? <span key={p.id} style={{ flexGrow: p.amount, background: p.color }} title={`${p.label}: ${compactSar(p.amount)}`} /> : null)) : <span className="sbar-empty" />}
      </div>
      {legend && (
        <ul className="sbar-legend" style={{ gridTemplateColumns: `repeat(${Math.min(Math.max(parts.length, 1), 6)}, minmax(0, 1fr))` }}>
          {parts.map((p) => {
            const body = <><span className="sbar-name"><i style={{ background: p.color }} aria-hidden="true" />{p.label}</span><b>{compactSar(p.amount)}</b><small>{p.count} deal{p.count === 1 ? '' : 's'}</small></>;
            return <li key={p.id} className={p.count ? '' : 'is-empty'}>{p.to ? <Link to={p.to}>{body}</Link> : body}</li>;
          })}
        </ul>
      )}
    </div>
  );
}
